import { Component, inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IIhcPublicRecord } from 'app/models/licenses/in-home-care/ihc-public-record';
import { InHomeCareLicenseService } from 'app/services/license/in-home-care/in-home-care-license.service';

@Component({
  selector: 'app-licensed-agencies',
  templateUrl: './licensed-agencies.component.html',
  styleUrls: ['./licensed-agencies.component.scss']
})
export class LicensedAgenciesComponent {

  public agencies: IIhcPublicRecord[] = [];

  public agencyColumns: string [] = ['licenseNumber', 'expirationDate', 'legalName', 'dba', 'classification', 'street', 'city', 'state', 'zip'];
  public agencySource = new MatTableDataSource<IIhcPublicRecord>(this.agencies);
  @ViewChild('agencyPaginator', {static: false}) agencyPaginator: MatPaginator;
  @ViewChild('agencySort', {static: false}) agencySort: MatSort;

  public sharedService = inject(SharedService);
  public licenseService = inject(InHomeCareLicenseService);

  ngOnInit(): void {
    this.getPublicRecords();
  }

  getPublicRecords(): void {
    this.licenseService.getPublicRecords().subscribe({
      next: response => this.agencies = response,
      error: e => {
        this.sharedService.toastr.error("Error getting public records");
        console.log('Error getting public records', e);
      },
      complete: () => this.updateAgencyTable()
    });
  }

  updateAgencyTable(): void {
    setTimeout(() => {
      this.agencySource.data = this.agencies;
      this.agencySource.paginator = this.agencyPaginator;
      this.agencySource.sort = this.agencySort;
    }, 500);
  }

  downloadDocument(): void {
    this.licenseService.downloadLicensedAgenciesReport().subscribe({
      next: response => this.saveFile("Licensed-Agencies.csv", response),
      error: e => {
        this.sharedService.toastr.error("Could not download document");
        console.log('Error downloading document', e);
      }
    });
  }

  saveFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement("a");
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
}
